export function openMakeUpFiltrate (options) {
    return new Promise((resolve, reject) => {
        app.router.push("/makeUpListFiltrate", route => {
            route.meta._resolve = resolve
            route.meta._reject = reject
            route.meta.options = options
        }, err => {
            console.log(err);
        })
    })
}